import { Button, Inline } from 'canoe';
import { useFormikContext } from 'formik';
import React from 'react';

import { ContentPlacement, positioningOptions, SelectorLocation } from '@candu-ai/placement/types';
import {
  InlineSelectorLocationForm,
} from 'craft/containers/Toolbox/tabs/Placements/InlinePlacements/components/InlineSelector/InlineSelectorLocationForm';
import {
  ActiveStepHeader,
  CompletedStepSettings,
  EditLinkButton,
  StepCircle,
  StepSubtitle,
  StepTitle,
} from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { FormState } from 'craft/containers/Toolbox/tabs/Placements/constants';
import { useToolboxTab } from 'craft/state';

interface StepTwoProps {
  active: boolean;
  onEdit: VoidFunction;
  onCancel: VoidFunction;
  onSave: (value?: string) => void;
  state: FormState;
}

export const FormStep2 = ({ active, onEdit, state, onCancel, onSave }: StepTwoProps) => {
  const { values } = useFormikContext<ContentPlacement>();
  const { forcePlacementsTab } = useToolboxTab();

  if (active) {
    return (
      <div>
        {!values.location ? (
          <ActiveStepHeader center>
            <StepCircle>2</StepCircle>
            <StepTitle size="short">Position?</StepTitle>
            <StepSubtitle>Above, below, or replace existing content</StepSubtitle>
          </ActiveStepHeader>
        ) : (
          <StepTitle size="short">2. Position</StepTitle>
        )}

        <InlineSelectorLocationForm
          state={state}
          onSave={onSave}
          onCancel={state === FormState.UPDATE ? onCancel : undefined}
        />
      </div>
    );
  }

  return (
    <div>
      <StepTitle size="short">2. Position</StepTitle>

      {state === 'update' ? (
        <CompletedStepSettings>
          <Inline space="xs">
            <span>
              <strong>Position</strong>
            </span>
            <span>
              {
                positioningOptions.find(
                  (pos) => pos.value === (values.location || SelectorLocation.START),
                )?.label
              }
            </span>
          </Inline>
          <EditLinkButton
            appearance="text"
            inline
            size="small"
            variant="white"
            fontWeight="xbold"
            onClick={onEdit}
            disabled={forcePlacementsTab}
          >
            edit
          </EditLinkButton>
        </CompletedStepSettings>
      ) : (
        <Button variant="secondary" fullWidth disabled mt="s">
          Start Editing Content
        </Button>
      )}
    </div>
  );
};
